import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M7.5.391C3.895.391 1 2.778 1 5.672c0 1.22.482 2.336 1.32 3.225-.355.99-1.142 1.854-1.168 1.854-.177.177-.203.431-.127.66.102.228.33.355.584.355 1.55 0 2.793-.635 3.53-1.168a7.923 7.923 0 0 0 2.361.356c3.58 0 6.5-2.362 6.5-5.282 0-2.894-2.92-5.28-6.5-5.28Zm0 9.344a6.621 6.621 0 0 1-2.006-.305l-.584-.178-.482.356a5.664 5.664 0 0 1-1.473.736c.203-.304.38-.66.508-1.015l.28-.711-.534-.559c-.457-.482-.99-1.295-.99-2.387C2.219 3.438 4.58 1.61 7.5 1.61c2.895 0 5.281 1.828 5.281 4.062 0 2.26-2.386 4.063-5.281 4.063Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }